export const GET_ACADEMIC_YEARS = "GET_ACADEMIC_YEARS"
export const GET_ACADEMIC_YEARS_FAIL = "GET_ACADEMIC_YEARS_FAIL"
export const GET_ACADEMIC_YEARS_SUCCESS = "GET_ACADEMIC_YEARS_SUCCESS"

export const ADD_NEW_ACADEMIC_YEAR = "ADD_NEW_ACADEMIC_YEAR"
export const ADD_ACADEMIC_YEAR_SUCCESS = "ADD_ACADEMIC_YEAR_SUCCESS"
export const ADD_ACADEMIC_YEAR_FAIL = "ADD_ACADEMIC_YEAR_FAIL"

export const UPDATE_ACADEMIC_YEAR = "UPDATE_ACADEMIC_YEAR"
export const UPDATE_ACADEMIC_YEAR_SUCCESS = "UPDATE_ACADEMIC_YEAR_SUCCESS"
export const UPDATE_ACADEMIC_YEAR_FAIL = "UPDATE_ACADEMIC_YEAR_FAIL"

export const DELETE_ACADEMIC_YEAR = "DELETE_ACADEMIC_YEAR"
export const DELETE_ACADEMIC_YEAR_SUCCESS = "DELETE_ACADEMIC_YEAR_SUCCESS"
export const DELETE_ACADEMIC_YEAR_FAIL = "DELETE_ACADEMIC_YEAR_FAIL"





export const GET_ACTIVE_ACADEMIC_YEARS = "GET_ACTIVE_ACADEMIC_YEARS";
export const GET_ACTIVE_ACADEMIC_YEARS_SUCCESS = "GET_ACTIVE_ACADEMIC_YEARS_SUCCESS";
export const GET_ACTIVE_ACADEMIC_YEARS_FAIL = "GET_ACTIVE_ACADEMIC_YEARS_FAIL";